import React, { useState } from 'react';
import { Menu, X, Briefcase, MapPin } from 'lucide-react';
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/YkZ8cAkm4wWJcYB3A';
export type ServiceType = 'foretagsbestallning' | 'manadens_meny' | 'catering_event';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
  onJobsClick: () => void;
  onBusinessOrder?: () => void;
  onScrollToCatalog?: () => void;
}
export function Navigation({
  onOrderClick,
  onJobsClick,
  onBusinessOrder,
  onScrollToCatalog
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    if (type === 'foretagsbestallning' && onBusinessOrder) {
      onBusinessOrder();
    } else if (type === 'catering_event' && onScrollToCatalog) {
      onScrollToCatalog();
    } else {
      onOrderClick(type);
    }
    setIsOpen(false);
  };
  const handleJobsClick = () => {
    onJobsClick();
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställning',
    type: 'foretagsbestallning'
  }, {
    label: 'Catering & Event',
    type: 'catering_event'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#F2EDE4] border-b border-[#7C8062]/15 shadow-sm" data-id="element-661">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-662">
        <div className="flex justify-center items-center h-12" data-id="element-663">
          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-664">
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-665">
                {link.label}
              </button>)}
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-666">
              <MapPin className="w-4 h-4" data-id="element-667" />
              Öppettider & Hitta hit
            </a>
            <button onClick={handleJobsClick} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-668">
              <Briefcase className="w-4 h-4" data-id="element-669" />
              Jobba hos oss
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-670">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 focus:outline-none transition-colors" aria-label="Meny" aria-expanded={isOpen} data-id="element-671">
              {isOpen ? <X className="h-5 w-5" data-id="element-672" /> : <Menu className="h-5 w-5" data-id="element-673" />}
              <span className="text-sm font-medium tracking-wide" data-id="element-674">
                {isOpen ? 'Stäng' : 'Meny'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#F2EDE4] border-t border-[#7C8062]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-675">
          <div className="px-4 pt-3 pb-4 space-y-1" data-id="element-676">
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-677">
              Beställ & Tjänster
            </p>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-678">
                {link.label}
              </button>)}
            <div className="h-px bg-[#7C8062]/10 my-2" data-id="element-679" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-680">
              Besök oss
            </p>
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-681">
              <MapPin className="w-5 h-5" data-id="element-682" />
              Öppettider & Hitta hit
            </a>
            <div className="h-px bg-[#7C8062]/10 my-2" data-id="element-683" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-684">
              Karriär
            </p>
            <button onClick={handleJobsClick} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-685">
              <Briefcase className="w-5 h-5" data-id="element-686" />
              Jobba hos oss
            </button>
          </div>
        </div>}
    </nav>;
}